import React, { useState, useRef, useContext, useEffect, ReactElement } from "react"
import { AuthContext } from "../contexts/auth";
import Fetching from "./fetching";




export default function UploadForm(props) {
  const formRef = useRef(null);
  const [file, setFile] = useState(null)
  const [data, setData] = useState({})

  const preventDefault = (e) => {
    e.preventDefault()
  };

  const preventDefaultWithUplaod = (e) => {
    e.preventDefault()
    if (!e?.dataTransfer.files) {
      return
    }
    setFile(e.dataTransfer.files[0])
  };

  useEffect(() => {
    // prevent default behavior from changing page on file drop
    window.addEventListener('dragover', preventDefault);
    window.addEventListener('drop', preventDefaultWithUplaod)

    return () => {
      window.removeEventListener('dragover', preventDefault);
      window.removeEventListener('drop', preventDefault);
    };
  }, []);


  const { token } = useContext(AuthContext)

  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState(null)
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedMonth, setSelectedMonth] = useState("");

  const uploadFile = (e) => {
    if (!e?.target.files) {
      return
    }
    console.log(e.target.files[0])
    setFile(e.target.files[0])
  }

  const updateCheckbox = (name, value) => {
    setData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const changeData = (e) => {

    setData({
      ...data,
      [e.target.name]: e.target.value
    })
  }

  const submitForm = async (e) => {
    e.preventDefault()

    if (!formRef.current) {
      console.error("Form reference not found");
      return;
    }

    const formElements = formRef.current.elements;
    const inputValues = {};

    const formData = new FormData();

    for (let i = 0; i < formElements.length; i++) {
      const element = formElements[i];

      // if (element.tagName === "INPUT" || element.tagName === "TEXTAREA" || element.tagName === "SELECT") {
      //   inputValues[element.name] = element.value;
      // }
      if (
        element instanceof HTMLInputElement ||
        element instanceof HTMLTextAreaElement ||
        element instanceof HTMLSelectElement
      ) {
        if (element.type === "checkbox") {
          inputValues[element.name] = element.checked;
          formData.append(element.name, element.checked);
        } else {
          inputValues[element.name] = element.value;
          formData.append(element.name, element.value);
        }
      }
    }

    if (!file) {
      setError({ file: ["Il file è obbligatorio."] });
      return;
    } else {
      inputValues["file"] = file;
      formData.append("file", file);
    }

    setSelectedYear(inputValues.year)
    setSelectedMonth(inputValues.month)
    setLoading(true)
    setError(null)
    setMessage(null)
    let response
    try {
      response = await props.submitAction(token, inputValues);
      setLoading(false);
      setMessage(response?.message || 'Operazione completata');
      setFile(null);
    } catch (err) {
      setLoading(false);
      setMessage(null);
    
      if (err.response && err.response.data) {
        setError(err.response.data);
      } else {
        setError({ generico: err.message || 'Si è verificato un errore sconosciuto.' });
      }
      console.log(err);
    }
  }

  const renderErrorMessages = (errors, level = 0) => {
    return Object.entries(errors).map(([field, messages], index) => {
      if (Array.isArray(messages)) {
        return (
          <div key={`${level}-${index}`}>
            <strong className="capitalize">{field}:</strong> {messages.join(', ')}
          </div>
        );
      } else if (typeof messages === 'object' && messages !== null) {
        return (
          <div key={`${level}-${index}`}>
            <strong className="capitalize">{field}:</strong>
            <div className="ml-4">{renderErrorMessages(messages, level + 1)}</div>
          </div>
        );
      } else {
        return (
          <div key={`${level}-${index}`}>
            <strong className="capitalize">{field}:</strong> {String(messages)}
          </div>
        );
      }
    });
  };


  if (loading && !error) {
    return <Fetching />
  }


  return (
    <form onSubmit={submitForm} ref={formRef}>

      {error && (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4 text-sm" role="alert">
          {typeof error === 'string'
            ? <span className="block sm:inline">{error}</span>
            : renderErrorMessages(error)}
        </div>
      )}

      {message && <>
        <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative mb-4 text-sm" role="alert">
          <span className="block sm:inline"> {message}</span>
        </div>
        {
          props.message?.success && 
          <div className="bg-orange-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4 text-sm" role="alert">
            <strong className="font-bold">
            {props.message?.success instanceof Function
              ? props.message.success({
                  anno: selectedYear,
                  mese: selectedMonth,
                })
              : props.message.success}
            </strong> <br />
          </div>
        }
      </>}

      {props.fields.map((field) => (
        <div className="mb-4">
          <label className="block text-grey-700 text-sm font-bold mb-2" htmlFor={field.name}>
            {field.label}
          </label>
          {/* case on field type */}
          {field.type === 'file' && (<></>)}
          {field.type === 'text' && (<input type="text" name={field.name} id={field.name} onChange={changeData} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"/>)}
          {field.type === 'select' && (
            <select name={field.name} id={field.name} onChange={changeData} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline">
              <option value="">Seleziona</option>
              {field.options.map((option) => (
                <option value={option.value}>{option.label}</option>
              ))}
            </select>
          )}
          {
            field.type === 'radio' && (
              <div className="flex items-center ">
                {field.options.map((option) => (
                  <label className="inline-flex items-center mr-4">
                    <input type="radio" className="form-radio" name={field.name} value={option.value} onChange={changeData} 
                      checked={data[field.name] ? data[field.name] === option.value : field.defaultChecked} />
                    <span className="ml-2">{option.label}</span>
                  </label>
                ))}
              </div>
            )
          }
          {
            field.type === 'checkbox' && (
              <div className="flex items-center ">
                {field.options.map((option) => (
                  <label className="inline-flex items-center mr-4">
                    <input
                      type="checkbox"
                      className="form-checkbox"
                      name={field.name}
                      checked={data[field.name]}
                      defaultChecked={true}
                      onChange={(e) => {
                        updateCheckbox(field.name, e.target.checked);
                      }}
                    />
                    <span className="ml-2">{option.label}</span>
                  </label>
                ))}
              </div>
            )
          }
          {
            field.type === 'float' && (
              <input
                //className="shadow appearaasnce-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id={field.name}
                name={field.name}
                step="0.01"
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                defaultValue="0.01"
                type="text"
                value={field.value}
                onChange={changeData} />
            )
          }
          {
            field.type === 'date' && (
              <input
                //className="shadow appearaasnce-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id={field.name}
                name={field.name}
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                type="date"
                value={field.value}
                onChange={changeData} />
            )
          }
          {
            field.type === 'hidden' && (
              <input type="hidden" name={field.name} value={field.value} />
            )
          }

        </div>
        ))}


      {(!file && props.enableUpload )&& (<div className="flex items-center justify-center w-full">
        <label htmlFor="dropzone-file" className="flex flex-col items-center justify-center w-full h-64 border-2 border-indigo-300 border-dashed rounded-lg cursor-pointer bg-indigo-50 dark:hover:bg-bray-800 dark:bg-indigo-700 hover:bg-indigo-100 dark:border-indigo-600 dark:hover:border-indigo-500 dark:hover:bg-indigo-600">
          <div className="flex flex-col items-center justify-center pt-5 pb-6">
            <svg className="w-10 h-10 mb-3 text-indigo-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"></path></svg>
            <p className="text-center mb-2 text-sm text-indigo-500 dark:text-indigo-400"><span className="font-semibold">Clicca per caricare un file <br/></span> o trascinalo qua sopra</p>
            <p className="text-xs text-indigo-500 dark:text-indigo-400">.PDF (MAX. 10MB)</p>
          </div>
          <input id="dropzone-file" type="file" className="hidden" onChange={uploadFile} />
        </label>
      </div>)}

      {(file && props.enableUpload) && (<div className="flex items-center justify-center w-full" onClick={() => setFile(null)}>
        <label htmlFor="dropzone-file" className="flex flex-col items-center justify-center w-full h-64 border-2 border-indigo-300 border-dashed rounded-lg cursor-pointer bg-indigo-50 dark:hover:bg-bray-800 dark:bg-indigo-700 hover:bg-indigo-100 dark:border-indigo-600 dark:hover:border-indigo-500 dark:hover:bg-indigo-600">
          <div className="flex flex-col items-center justify-center pt-5 pb-6">
            <svg className="w-10 h-10 mb-3 text-indigo-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"></path></svg>
            <p className="text-center mb-2 text-sm text-indigo-500 dark:text-indigo-400"><span className="font-semibold">{file.name}</span></p>
          </div>
        </label>
      </div>)}

      <div className="flex items-center justify-center mt-4">
        <button type="submit" className="w-full py-3 px-4 bg-indigo-600 hover:bg-indigo-500 rounded-md text-white text-md font-semibold">
          {props.submitLabel}
        </button>
      </div>
      
    </form>
  )
}




 // <div className="flex items-center justify-center">
    //   <div className="mx-auto w-full max-w-[550px] bg-white">
    //     <form
    //       className="py-6"
    //       action="https://formbold.com/s/FORM_ID"
    //       method="POST"
    //     >
    //       <div className="mb-5">
    //         <label
    //           htmlFor="email"
    //           className="mb-3 block text-base font-medium text-[#07074D]"
    //         >
    //           Send files to this email:
    //         </label>
    //         <input
    //           type="email"
    //           name="email"
    //           id="email"
    //           placeholder="example@domain.com"
    //           className="w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md"
    //         />
    //       </div>

    //       <div className="mb-6 pt-4">
    //         <label className="mb-5 block text-md font-semibold text-[#07074D]">
    //           Carica il file
    //         </label>

    //         <div className="mb-8">
    //           <input type="file" name="file" id="file" className="sr-only" />
    //           <label
    //             htmlFor="file"
    //             className="relative flex min-h-[200px] items-center justify-center rounded-md border border-dashed border-[#e0e0e0] p-12 text-center"
    //           >
    //             <div>
    //               <span className="mb-2 block text-md font-semibold text-[#07074D]">
    //                 Trascina qua il file
    //               </span>
    //               <span className="mb-2 block text-base font-medium text-[#6B7280]">
    //                 oppure
    //               </span>
    //               <span
    //                 className="inline-flex rounded border border-[#e0e0e0] py-2 px-7 text-base font-medium text-[#07074D]"
    //               >
    //                 Cercalo nel computer
    //               </span>
    //             </div>
    //           </label>
    //         </div>

    //         {/* <div className="mb-5 rounded-md bg-[#F5F7FB] py-4 px-8">
    //           <div className="flex items-center justify-between">
    //             <span className="truncate pr-3 text-base font-medium text-[#07074D]">
    //               banner-design.png
    //             </span>
    //             <button className="text-[#07074D]">
    //               <svg
    //                 width="10"
    //                 height="10"
    //                 viewBox="0 0 10 10"
    //                 fill="none"
    //                 xmlns="http://www.w3.org/2000/svg"
    //               >
    //                 <path
    //                   fill-rule="evenodd"
    //                   clip-rule="evenodd"
    //                   d="M0.279337 0.279338C0.651787 -0.0931121 1.25565 -0.0931121 1.6281 0.279338L9.72066 8.3719C10.0931 8.74435 10.0931 9.34821 9.72066 9.72066C9.34821 10.0931 8.74435 10.0931 8.3719 9.72066L0.279337 1.6281C-0.0931125 1.25565 -0.0931125 0.651788 0.279337 0.279338Z"
    //                   fill="currentColor"
    //                 />
    //                 <path
    //                   fill-rule="evenodd"
    //                   clip-rule="evenodd"
    //                   d="M0.279337 9.72066C-0.0931125 9.34821 -0.0931125 8.74435 0.279337 8.3719L8.3719 0.279338C8.74435 -0.0931127 9.34821 -0.0931123 9.72066 0.279338C10.0931 0.651787 10.0931 1.25565 9.72066 1.6281L1.6281 9.72066C1.25565 10.0931 0.651787 10.0931 0.279337 9.72066Z"
    //                   fill="currentColor"
    //                 />
    //               </svg>
    //             </button>
    //           </div>
    //         </div> */}

    //         {/* <div className="rounded-md bg-[#F5F7FB] py-4 px-8">
    //           <div className="flex items-center justify-between">
    //             <span className="truncate pr-3 text-base font-medium text-[#07074D]">
    //               banner-design.png
    //             </span>
    //             <button className="text-[#07074D]">
    //               <svg
    //                 width="10"
    //                 height="10"
    //                 viewBox="0 0 10 10"
    //                 fill="none"
    //                 xmlns="http://www.w3.org/2000/svg"
    //               >
    //                 <path
    //                   fill-rule="evenodd"
    //                   clip-rule="evenodd"
    //                   d="M0.279337 0.279338C0.651787 -0.0931121 1.25565 -0.0931121 1.6281 0.279338L9.72066 8.3719C10.0931 8.74435 10.0931 9.34821 9.72066 9.72066C9.34821 10.0931 8.74435 10.0931 8.3719 9.72066L0.279337 1.6281C-0.0931125 1.25565 -0.0931125 0.651788 0.279337 0.279338Z"
    //                   fill="currentColor"
    //                 />
    //                 <path
    //                   fill-rule="evenodd"
    //                   clip-rule="evenodd"
    //                   d="M0.279337 9.72066C-0.0931125 9.34821 -0.0931125 8.74435 0.279337 8.3719L8.3719 0.279338C8.74435 -0.0931127 9.34821 -0.0931123 9.72066 0.279338C10.0931 0.651787 10.0931 1.25565 9.72066 1.6281L1.6281 9.72066C1.25565 10.0931 0.651787 10.0931 0.279337 9.72066Z"
    //                   fill="currentColor"
    //                 />
    //               </svg>
    //             </button>
    //           </div>
    //           <div className="relative mt-5 h-[6px] w-full rounded-lg bg-[#E2E5EF]">
    //             <div
    //               className="absolute left-0 right-0 h-full w-[75%] rounded-lg bg-[#6A64F1]"
    //             ></div>
    //           </div>
    //         </div> */}
    //       </div>

    //       <div>
    //         <button
    //           className="hover:shadow-form w-full rounded-md bg-[#6A64F1] py-3 px-8 text-center text-base font-semibold text-white outline-none"
    //         >
    //           Carica
    //         </button>
    //       </div>
    //     </form>
    //   </div>
    // </div>
